import { Injectable } from "@angular/core";
import { BaseGridResponse } from "planning-portal-library/src/lib/data/shared/base-grid.response";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { CommittedOrder, GetCommittedOrderRequest } from "../../domain";
import { CommittedOrdersRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetCommittedOrdersUsecase implements UseCase<BaseRequest<GetCommittedOrderRequest>, BaseGridResponse<CommittedOrder>> {

  constructor(private committedOrdersRepository: CommittedOrdersRepository) {
  }

  execute(params: BaseRequest<GetCommittedOrderRequest>): Observable<BaseGridResponse<CommittedOrder>> {
    return this.committedOrdersRepository.getCommittedOrders(params);
  }

}
